// Actionable smart suggestions for the selected document (rule-based: duplicates, staleness, mis-filed, wrong applicant, incomplete sets).
import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { eyebrow } from './ui';

const TONE = { amber: 'bg-[#FF9500]', rose: 'bg-[#FF3B30]', sky: 'bg-[#007AFF]', violet: 'bg-[#AF52DE]' };

export function Suggestions({ checks, onAction, busy }) {
  if (!checks.length) return null;
  return (
    <section data-testid="obd-doc-checks">
      <p className={`${eyebrow} flex items-center gap-1.5`}><Sparkles className="h-3.5 w-3.5 text-[#AF52DE]" /> Suggestions · {checks.length}</p>
      <ul className="mt-2 overflow-hidden rounded-[14px] bg-[#AF52DE]/[0.06]">
        {checks.map((x, i) => (
          <li key={i} className="flex items-start gap-3 border-b border-black/[0.05] px-4 py-3 last:border-b-0" data-testid={`obd-doc-check-${i}`}>
            <span className={`mt-[6px] h-1.5 w-1.5 shrink-0 rounded-full ${TONE[x.tone] || TONE.violet}`} />
            <p className="min-w-0 flex-1 text-[13px] leading-snug text-[#1d1d1f]">{x.text}</p>
            {x.action && <button type="button" onClick={() => onAction(x.action)} disabled={busy} data-testid={`obd-doc-check-action-${i}`} className="inline-flex shrink-0 items-center gap-1 rounded-full bg-white px-3 py-1 text-[12px] font-medium text-[#15133A] shadow-[0_1px_2px_rgba(0,0,0,0.08)] transition-[transform,background-color] duration-200 hover:bg-[#15133A] hover:text-white active:scale-[0.97] disabled:opacity-40">{x.action.label} <ArrowRight className="h-3 w-3" /></button>}
          </li>
        ))}
      </ul>
      <p className="mt-1.5 px-1 text-[11px] text-[#86868b]">Rule-based — confirm before acting.</p>
    </section>
  );
}
